import axios from "axios";
import API_BASE_URL from "../config";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export const adminPasswordLogin = async (payload) => {
  try {
    const res = await axiosInstance.post("admin-password-login", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Admin login failed. Please try again.",
    };
  }
};

export const adminSendOtp = async (payload) => {
  try {
    const res = await axiosInstance.post("admin-send-otp", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to send OTP. Please try again.",
    };
  }
};

export const adminVerifyOtp = async (payload) => {
  try {
    const res = await axiosInstance.post("admin-verify-otp", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "OTP verification failed. Please try again.",
    };
  }
};

export const adminResendOtp = async (payload) => {
  try {
    const res = await axiosInstance.post("admin-resend-otp", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to resend OTP. Please try again.",
    };
  }
};

export const adminForgotPassword = async (payload) => {
  try {
    const res = await axiosInstance.post("admin-forgot-password", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to send OTP. Please try again.",
    };
  }
};

export const adminVerifyForgotOtp = async (payload) => {
  try {
    const res = await axiosInstance.post("admin-forgot-verify-otp", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "OTP verification failed. Please try again.",
    };
  }
};

export const adminResetPassword = async (payload) => {
  try {
    const res = await axiosInstance.post("admin-reset-password", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to reset password. Please try again.",
    };
  }
};

export const fetchTeamRequests = async (payload) => {
  try {
    const res = await axiosInstance.post("view-pilots", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to fetch team requests.",
    };
  }
};

export const adminSendDeviceOtp = async (payload) => {
  try {
    const res = await axiosInstance.post("admin-send-device-otp", payload);
    return res.data;
  } catch (err) {
    return {
      error: err.response?.data?.error || "Failed to send OTP. Please try again.",
    };
  }
};

export const adminVerifyAndApproveDevice = async (payload) => {
  try {
    const res = await axiosInstance.post("admin-verify-and-approve-device", payload);
    return res.data;
  } catch (err) {
    return {
      error: err.response?.data?.error || "Failed to verify OTP. Please try again.",
    };
  }
};

export const updatePilotStatus = async (payload) => {
  try {
    const res = await axiosInstance.post("registration-approved-rejected", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to update pilot status. Please try again.",
    };
  }
};

export const fetchMissions = async () => {
  try {
    const response = await axiosInstance.post('/view-missions', {});
    return response.data;
  } catch (error) {
    console.error('Error fetching missions:', error);
    throw error;
  }
};

export const fetchMissionEvents = async (
  vehiclePage = 1,
  vehiclesPerPage = 10,
  missionPage = 1,         
  missionsPerPage = 5,      
  eventsPage = 1,
  eventsPerPage = 5,
  filterType = "month",
  date = null,
  startDate = null,
  endDate = null
) => {
  try {
    const payload = {
      filter_type: filterType,
      vehicle_page: vehiclePage,
      vehicles_per_page: vehiclesPerPage,

      mission_page: missionPage,              
      missions_per_page: missionsPerPage,     

      events_page: eventsPage,
      events_per_page: eventsPerPage
    };

    if (filterType === "custom") {
      payload.start_date = startDate;
      payload.end_date = endDate;
    } else {
      payload.date = date || new Date().toISOString().split("T")[0];
    }

    const response = await axiosInstance.post('/get-mission-events', payload);
    return response.data;
  } catch (error) {
    console.error('Error fetching mission events:', error);
    throw error;
  }
};

export const fetchDroneFlyingDetails = async () => {
  try {
    const response = await axiosInstance.post('/drone-flying-details', {});
    return response.data;
  } catch (error) {
    console.error('Error fetching drone flying details:', error);
    throw error;
  }
};

export const fetchDroneSprayData = async () => {
  try {
    const response = await axiosInstance.post('/drone-spray-area-plot', {});
    return response.data;
  } catch (error) {
    console.error('Error fetching spray data:', error);
    throw error;
  }
};

export const fetchDashboardData = async () => {
  try {
    const fetchDroneBatteryStatus = async () => ({ vehicles: [] });
    const fetchDronePositions = async () => ({ vehicles: [] });
    const fetchDroneFlightStatus = async () => ({ vehicles: [] });
    
    const [
      missionsResponse,
      batteryResponse,
      positionResponse,
      flightStatusResponse,
      sprayResponse
    ] = await Promise.allSettled([
      fetchMissions(),
      fetchDroneBatteryStatus(),
      fetchDronePositions(),
      fetchDroneFlightStatus(),
    ]);

    return {
      missions: missionsResponse.status === 'fulfilled' ? missionsResponse.value : { vehicles: [] },
      battery: batteryResponse.status === 'fulfilled' ? batteryResponse.value : { vehicles: [] },
      positions: positionResponse.status === 'fulfilled' ? positionResponse.value : { vehicles: [] },
      flightStatus: flightStatusResponse.status === 'fulfilled' ? flightStatusResponse.value : { vehicles: [] },
      sprayData: sprayResponse.status === 'fulfilled' ? sprayResponse.value : { vehicles: [] },
    };
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    throw error;
  }
};

export const fetchWeeklyFlightsByDate = async (week_date) => {
  try {
    const payload = {
      week_date: week_date
    };
    const response = await axiosInstance.post('/weekly-flights-by-date', payload);
    return response.data;
  } catch (error) {
    console.error('Error fetching weekly flights:', error);
    throw error;
  }
};

export const fetchWeeklyFlightsPerDrone = async (week_date) => {
  try {
    const payload = {
      week_date: week_date
    };
    const response = await axiosInstance.post('/weekly-flights-per-drone', payload);
    return response.data;
  } catch (error) {
    console.error('Error fetching weekly flights per drone:', error);
    throw error;
  }
};

export const fetchWeeklyFlightSummary = async (week_date) => {
  try {
    const payload = {
      week_date: week_date
    };
    const response = await axiosInstance.post('/weekly-flight-summary', payload);
    return response.data;
  } catch (error) {
    console.error('Error fetching weekly flight summary:', error);
    throw error;
  }
};

export const fetchFlightStats = async (payload) => {
  try {
    const response = await axiosInstance.post('/flight-count-by-date-filter', payload);
    return response.data;
  } catch (error) {
    console.error('Error fetching flight stats:', error);
    throw error;
  }
};

export const fetchPilotsAndVehicles = async (payload = {}) => {
  try {
    const res = await axiosInstance.post("view-vehicles", {
      action: payload.action || "view",   
      ...payload
    });

    return res.data;
  } catch (err) {
    return {
      error: err.response?.data?.error || "Failed to fetch pilots and vehicles.",
    };
  }
};

export const updateVehicleMissionLimit = async (payload) => {
  try {
    const res = await axiosInstance.post("view-vehicles", {
      action: "add",
      ...payload
    });

    return res.data;
  } catch (err) {
    return {
      error: err.response?.data?.error || "Failed to update mission limit.",
    };
  }
};

export const updateVehicleUIN = async (payload) => {
  try {
    const response = await axiosInstance.post(
      '/update-vehicle-uin',
      payload
    );

    return response.data;

  } catch (error) {
    console.error('Error updating vehicle UIN:', error);
    
    return {
      error: error.response?.data?.error || 
             error.response?.data?.message || 
             "Failed to update vehicle UIN. Please try again.",
      status_code: error.response?.status || 500
    };
  }
};

// export const fetchAllMissions = async (payload = {}) => {
//   try {
//     const requestPayload = {
//       start_date: payload.start_date ,
//       end_date: payload.end_date ,
//       page: payload.page ,
//       per_page: payload.per_page || 10  
//     };
//     if (payload.status && payload.status !== 'all') {
//       requestPayload.status = payload.status;
//     }
//     if (payload.search && payload.search.trim() !== '') {
//       requestPayload.search = payload.search.trim();
//     }
//     const response = await axiosInstance.post('/view-all-missions', requestPayload);
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching all missions:', error);
//     throw error;
//   }
// };

export const fetchAllMissions = async (payload = {}) => {
  try {

    const requestPayload = {
  filter_type: payload.filter_type || "custom",

  start_date: payload.start_date,
  end_date: payload.end_date,

  page: payload.page || 1,
  per_page: payload.per_page || 10,
};

// Optional Filters
if (payload.pilot_email?.trim()) {
  requestPayload.pilot_email = payload.pilot_email.trim();
}

if (payload.drone_id) {
  requestPayload.drone_id = payload.drone_id;
}

// Time filter should apply ONLY when user clicks Apply Filters
if (
  payload.time &&
  payload.time_type &&
  String(payload.time).trim() !== ""
) {
  requestPayload.time =
    typeof payload.time === "string" &&
    payload.time.includes("min")
      ? payload.time
      : `${parseFloat(payload.time)}min`;

  requestPayload.time_type = payload.time_type;
}

    // Search Support
    if (
      payload.search &&
      payload.search.trim() !== ""
    ) {
      requestPayload.pilot_email =
        payload.search.trim();
    }

    const response = await axiosInstance.post(
      "/view-all-missions",
      requestPayload
    );

    return response.data;

  } catch (error) {
    console.error(
      "Error fetching all missions:",
      error
    );

    throw error;
  }
};


// export const fetchRecentMissions = async (
//   limit = 5,
//   filterType = "week",
//   startDate = null,
//   endDate = null,
//   pilotEmail = "",
//   time = null,
//   timeType = null
// ) => {
//   try {

//     let payload = {};

//     if (
//       filterType === "custom" &&
//       startDate &&
//       endDate
//     ) {

//       payload = {
//         start_date: startDate,
//         end_date: endDate,
//         limit,
//         page: 1
//       };

//     } else {

//       const today = new Date()
//         .toISOString()
//         .split("T")[0];

//       payload = {
//         filter_type: filterType,
//         date: today,
//         limit,
//         page: 1
//       };
//     }

//     // Pilot Search
//     if (pilotEmail?.trim()) {
//       payload.pilot_email =
//         pilotEmail.trim();
//     }

//     // Time Filter
//     if (time && timeType) {
//       payload.time = `${time}min`;
//       payload.time_type = timeType;
//     }

//     const response = await axiosInstance.post(
//       "/view-all-missions",
//       payload
//     );

//     let missions = [];

//     if (response?.data?.type === "single") {
//       missions = response.data.missions || [];
//     }

//     else if (response?.data?.type === "multi") {
//       missions =
//         response.data.superadmin?.missions ||
//         response.data.superadmin_company?.missions ||
//         response.data.admin_companies?.missions ||
//         [];
//     }

//     else if (response?.data?.missions) {
//       missions = response.data.missions;
//     }

//     else if (Array.isArray(response?.data)) {
//       missions = response.data;
//     }

//     return missions.slice(0, limit);

//   } catch (error) {

//     console.error(
//       "Error fetching recent missions:",
//       error
//     );

//     return [];
//   }
// };

export const fetchRecentMissions = async (
  limit = 5,
  filterType = "week",
  startDate = null,
  endDate = null,
  pilotEmail = "",
  time = "",
  timeType = ""
) => {
  try {

    let payload = {};

    if (
      filterType === "custom" &&
      startDate &&
      endDate
    ) {

      payload = {
        start_date: startDate,
        end_date: endDate,
        limit,
        page: 1
      };

    } else {

      const today = new Date()
        .toISOString()
        .split("T")[0];

      payload = {
        filter_type: filterType,
        date: today,
        limit,
        page: 1
      };
    }

    // Pilot Search
    if (pilotEmail?.trim()) {
      payload.pilot_email =
        pilotEmail.trim();
    }

    // Time Filter
    if (
      time !== null &&
      time !== undefined &&
      time !== "" &&
      timeType !== null &&
      timeType !== undefined &&
      timeType !== ""
    ) {
      payload.time = `${time}min`;
      payload.time_type = timeType;
    }

    const response = await axiosInstance.post(
      "/view-all-missions",
      payload
    );

    let missions = [];

    if (response?.data?.type === "single") {
      missions = response.data.missions || [];
    }

else if (response?.data?.type === "multi") {

  // Show only available company missions
  if (response.data.superadmin?.missions?.length) {
    missions = response.data.superadmin.missions;
  }

  else if (response.data.admins?.missions?.length) {
    missions = response.data.admins.missions;
  }

  else {
    missions = [];
  }
}

    else if (response?.data?.missions) {
      missions = response.data.missions;
    }

    else if (Array.isArray(response?.data)) {
      missions = response.data;
    }

   return missions;

  } catch (error) {

    console.error(
      "Error fetching recent missions:",
      error
    );

    return [];
  }
};

export const fetchCardsTotalSummary = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/cards-total-summary",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching cards total summary:", error);
    throw error;
  }
};

export const fetchLiveDroneTracking = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/live-drone-tracking",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Live tracking error:", error);
    throw error;
  }
};

export const fetchPilotDroneMissionHistory = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/pilot-drone-mission-full-history",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Pilot drone mission history error:", error);
    throw error;
  }
};

export const fetchDeviceNotifications = async (payload = {}) => {
  try {
    const response = await axiosInstance.post(
      "/device-notifications",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Device notifications error:", error);
    throw error;
  }
};

// export const fetchNotifications = async () => {
//   try {
//     const response = await axiosInstance.post(
//       "/notifications",
//       {}
//     );

//     console.log("🔔 /api/notifications response:", response.data);

//     return response.data;
//   } catch (error) {
//     console.error(
//       "❌ Notifications API error:",
//       error.response?.data || error
//     );

//     return {
//       error:
//         error.response?.data?.error ||
//         "Failed to fetch notifications.",
//     };
//   }
// };

export const fetchNotifications = async (action = "count") => {
  try {
    const response = await axiosInstance.post(
      "/notifications",
      { action }
    );

    console.log(
      `🔔 /api/notifications (${action}) response:`,
      response.data
    );

    return response.data;
  } catch (error) {
    console.error(
      "❌ Notifications API error:",
      error.response?.data || error
    );

    return {
      error:
        error.response?.data?.error ||
        "Failed to fetch notifications.",
    };
  }
};

export const fetchMissionReplay = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/mission-replay",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Mission replay error:", error);
    throw error;
  }
};

export const adminLogout = async () => {
  try {
    const res = await axiosInstance.post("admin-logout", {});
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Logout failed. Please try again.",
    };
  }
};

export const updatePilotsStatus = async (payload) => {
  try {
    const res = await axiosInstance.post("update-pilot-status", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to update pilot status. Please try again.",
    };
  }
};

export const fetchDashboardSummary = async (payload) => {
  try {
    const res = await axiosInstance.post("dashboard", payload);

    return {
      dashboard: res.data.dashboard,
      missions: res.data.missions,
    };

  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to fetch dashboard summary.",
    };
  }
};

export const adminProfile = async () => {
  try {
    const res = await axiosInstance.post("admin-profile", {});
    return res.data;
  } catch (err) {
    return {
      error: err.response?.data?.error || "Failed to fetch profile data.",
    };
  }
};

// In your AdminApis.js, verify these functions:

export const viewVehicleServiceHistory = async (payload) => {
  try {
    console.log("viewVehicleServiceHistory called with:", payload);
    const response = await axiosInstance.post('/view-vehicle-service-history', payload);
    console.log("viewVehicleServiceHistory response:", response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching service history:', error);
    return {
      error: error.response?.data?.error || 
             error.response?.data?.message || 
             "Failed to fetch service history. Please try again.",
      status_code: error.response?.status || 500
    };
  }
};

export const addVehicleServiceHistory = async (payload) => {
  try {
    console.log("addVehicleServiceHistory called with:", payload);
    const response = await axiosInstance.post('/add-vehicle-service-history', payload);
    console.log("addVehicleServiceHistory response:", response.data);
    return response.data;
  } catch (error) {
    console.error('Error adding service history:', error);
    return {
      error: error.response?.data?.error || 
             error.response?.data?.message || 
             "Failed to add service history. Please try again.",
      status_code: error.response?.status || 500
    };
  }
};

// In AdminApis.js or similar API file
// export const fetchPilotDroneMissionQuickSearch = async (payload = {}) => {
//   try {
//     const today = new Date().toISOString().split("T")[0];

//     let filterType = payload.filter_type || "";

//     // Map frontend filter names to backend filter names
//     switch (filterType) {
//       case "today":
//         filterType = "day";
//         break;

//       case "current_week":
//         filterType = "week";
//         break;

//       case "current_month":
//         filterType = "month";
//         break;

//       case "current_year":
//         filterType = "year";
//         break;

//       default:
//         break;
//     }

//     const requestPayload = {
//       pilot_page: payload.pilot_page || 1,
//       pilots_per_page: payload.pilots_per_page || 2,
//       mission_page: payload.mission_page || 1,
//       missions_per_page: payload.missions_per_page || 5,
//     };

//     if (filterType) {
//       requestPayload.filter_type = filterType;
//     }

//     if (payload.date) {
//       requestPayload.date = payload.date;
//     } else if (filterType && filterType !== "custom") {
//       requestPayload.date = today;
//     }

//     // Pilot search
//     if (payload.pilot_search?.trim()) {
//       requestPayload.pilot_search = payload.pilot_search.trim();
//     }

//     // Suggestions only
//     if (payload.suggestions_only) {
//       requestPayload.suggestions_only = true;
//     }

//     // Drone filter
//     if (payload.drone_id?.trim()) {
//       requestPayload.drone_id = payload.drone_id.trim();
//     }

//     // Custom date range
//     if (
//       filterType === "custom" &&
//       payload.start_date &&
//       payload.end_date
//     ) {
//       requestPayload.start_date = payload.start_date;
//       requestPayload.end_date = payload.end_date;
//     }

//     // Time filter
//     if (payload.time_value?.trim()) {
//       let timeValue = payload.time_value.trim();

//       if (
//         !isNaN(parseFloat(timeValue)) &&
//         !timeValue.includes("min")
//       ) {
//         timeValue = `${parseFloat(timeValue)}min`;
//       }

//       requestPayload.time_value = timeValue;
//       requestPayload.time_type = payload.time_type || "gt";
//     }

//     console.log(
//       "Quick Search Request Payload:",
//       requestPayload
//     );

//     const response = await axiosInstance.post(
//       "/pilot-drone-mission-quick-search",
//       requestPayload
//     );

//     const data = response.data;

//     // ---------------------------------------------
//     // MULTI RESPONSE
//     // ---------------------------------------------
//     if (data.type === "multi") {
//       let companyData = null;

//       if (data.user_role === "superadmin") {
//         // SUPERADMIN -> ONLY superadmin company
//         companyData = data.superadmin_company;
//       } else if (data.user_role === "admin") {
//         // ADMIN -> admin company
//         companyData = data.admin_companies;
//       }

//       return {
//         ...data,

//         data: companyData?.data || [],

        
//         pilot_pagination:
//           companyData?.pilot_pagination || {},
//       };
//     }

//     // ---------------------------------------------
//     // SINGLE RESPONSE
//     // ---------------------------------------------
//     return data;

//   } catch (error) {
//     console.error(
//       "Error fetching pilot drone mission quick search:",
//       error
//     );

//     if (error.response?.status === 401) {
//       throw new Error(
//         "Unauthorized. Please login again."
//       );
//     }

//     throw error;
//   }
// };

export const fetchPilotDroneMissionQuickSearch = async (payload = {}) => {
  try {
    const today = new Date().toISOString().split("T")[0];

    let filterType = payload.filter_type || "";

    switch (filterType) {
      case "today":
        filterType = "day";
        break;

      case "current_week":
        filterType = "week";
        break;

      case "current_month":
        filterType = "month";
        break;

      case "current_year":
        filterType = "year";
        break;

      default:
        break;
    }

    const requestPayload = {
      pilot_page: payload.pilot_page || 1,
      pilots_per_page: payload.pilots_per_page || 2,
      mission_page: payload.mission_page || 1,
      missions_per_page: payload.missions_per_page || 5,
    };

    if (filterType) {
      requestPayload.filter_type = filterType;
    }

    if (payload.date) {
      requestPayload.date = payload.date;
    } else if (filterType && filterType !== "custom") {
      requestPayload.date = today;
    }

    if (payload.pilot_search?.trim()) {
      requestPayload.pilot_search =
        payload.pilot_search.trim();
    }

    if (payload.suggestions_only) {
      requestPayload.suggestions_only = true;
    }

    if (payload.drone_id?.trim()) {
      requestPayload.drone_id =
        payload.drone_id.trim();
    }

    if (
      filterType === "custom" &&
      payload.start_date &&
      payload.end_date
    ) {
      requestPayload.start_date = payload.start_date;
      requestPayload.end_date = payload.end_date;
    }

    if (payload.time_value?.trim()) {
      let timeValue = payload.time_value.trim();

      if (
        !isNaN(parseFloat(timeValue)) &&
        !timeValue.includes("min")
      ) {
        timeValue = `${parseFloat(timeValue)}min`;
      }

      requestPayload.time_value = timeValue;
      requestPayload.time_type =
        payload.time_type || "gt";
    }

    console.log(
      "Quick Search Request Payload:",
      requestPayload
    );

    const response = await axiosInstance.post(
      "/pilot-drone-mission-quick-search",
      requestPayload
    );

    const data = response.data;

    // ---------------------------------------------
    // MULTI RESPONSE
    // ---------------------------------------------
    if (data.type === "multi") {
      let companyData = null;

      // Superadmin response
      if (data.superadmin_company) {
        companyData = data.superadmin_company;
      }

      // Admin response
      else if (data.admin_companies) {
        companyData = data.admin_companies;
      }

      console.log(
        "MULTI RESPONSE COMPANY DATA:",
        companyData
      );

      return {
        ...data,

        data: companyData?.data || [],

        pilot_pagination:
          companyData?.pilot_pagination || {},

        companyData: companyData || null,
      };
    }

    // ---------------------------------------------
    // SINGLE RESPONSE
    // ---------------------------------------------
    return data;

  } catch (error) {
    console.error(
      "Error fetching pilot drone mission quick search:",
      error
    );

    if (error.response?.status === 401) {
      throw new Error(
        "Unauthorized. Please login again."
      );
    }

    throw error;
  }
};

export const generatePilotKey = async (payload) => {
  try {
    const res = await axiosInstance.post("generate-pilot-key", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to generate pilot key. Please try again.",
    };
  }
};

export const requestAdminProfileEdit = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "request-admin-profile-edit",
      payload
    );

    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to process profile edit request. Please try again.",
    };
  }
};

export const approveAdminProfileEdit = async (payload) => {
  try {
    const res = await axiosInstance.post("approve-admin-profile-edit", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to process profile edit request. Please try again.",
    };
  }
};

export const editAdminProfile = async (payload) => {
  try {
    const res = await axiosInstance.post("edit-admin-profile", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to update admin profile. Please try again.",
    };
  }
};

export const approvePilotProfileEdit = async (payload) => {
  try {
    const res = await axiosInstance.post("approve-pilot-profile-edit", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to process pilot profile edit request. Please try again.",
    };
  }
};